export const environment = {
    name: 'qual',
    production: true,
    apiUrl: 'https://qual-ramdam.bizzdev.net/api/',

    urlSite: 'https://qual-ramdam.bizzdev.net',

    apiDomain: 'https://qual-ramdam.bizzdev.net',
    identityApiUrl: 'https://qual-ramdam.bizzdev.net/identity/',
    whiteListedUrl: 'https://qual-ramdam.bizzdev.net/api',
    socialBlackListedUrl: 'https://qual-ramdam.bizzdev.net/api/user/socials/login',
    blacklistedUrl: 'https://qual-ramdam.bizzdev.net',
    returnUrl: 'https://172.16.1.95:4200',

    tokenKey: 'bizz-ramdam-token-admin',
    tokenExpKey: 'bizz-ramdam-token-exp-admin',
    rfTokenKey: 'bizz-ramdam-rf-token-admin',

    appName: 'RamDam',
    version: '0.0.1',


};